import { Step, StepperProps } from "common/components/Stepper";

interface Section {
  name: string;
  steps: number;
  order: number;
}

type Sections<T> = {
  [section in keyof T]: Section;
};

export function getProgressValue(step: number, totalSteps: number) {
  return Math.round((step / totalSteps) * 100);
}

export function getInitialSteps<T>(sections: Sections<T>): Step[] {
  const initialSteps: Step[] = [];

  let section: Section;
  const values: Section[] = Object.values(sections);
  for (section of values) {
    initialSteps[section.order] = {
      name: section.name,
      progress: section.order > 0 ? 0 : getProgressValue(1, section.steps),
    };
  }

  return initialSteps;
}

export function getProgressStep(
  stepperData: StepperProps,
  currentSection: Section,
  step: number
): StepperProps {
  const steps = Array.from(stepperData.steps);
  steps[currentSection.order].progress = getProgressValue(
    step,
    currentSection.steps
  );
  return {
    ...stepperData,
    steps,
  };
}

export function getProgressSectionBack(
  stepperData: StepperProps,
  currentSection: Section,
  previousSection: Section
): StepperProps {
  const steps = Array.from(stepperData.steps);
  steps[previousSection.order].progress = 100;
  steps[currentSection.order].progress = 0;

  return {
    ...stepperData,
    steps,
    currentStep: previousSection.order,
  };
}

export function getProgressSectionNext(
  stepperData: StepperProps,
  currentSection: Section,
  nextSection: Section
): StepperProps {
  const steps = Array.from(stepperData.steps);
  steps[nextSection.order].progress = getProgressValue(1, nextSection.steps);
  steps[currentSection.order].progress = 100;

  return {
    ...stepperData,
    steps,
    currentStep: nextSection.order,
  };
}
